export default __webpack_public_path__ + "235f7723989770e2eba66ac56b894cf0.png";